import * as z from "zod";

export const acceptAutoClaimsFiling = {
  name: "acceptAutoClaimsFiling" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
